import { useEffect, useState, useRef } from "react";
import { default as Steps } from "./sim-components/Steps";
import "./emulator.css";
import emuJSON from "../json/emulator.json";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Tooltip from "@material-ui/core/Tooltip";
import { default as BackButton } from "./BackButton";
import Disclaimer from "./Disclaimer";
import CloseIcon from "@material-ui/icons/Close";
import Temp from "./Temp";
export default function Sim({
  myScreen,
  hideButtons,
  highlighted,
  transitionSim,
  setStepNumber,
  customButton,
  setEmulatorStep,
  hideScreenBtns,
  hideRemoteBtns,
  stepLength,
  setSimPageNum,
  emulatorStep,
  switchScreens,
  pageJSON,
  simPageNum,
  setIsEmulatorStep,
  setTotalSteps,
  page,
  hideEOv,
  setHideEOv,
  isSingleStepScreen,
  setIsSingleStepScreen,
  currentScreen,
  setCurrentScreen,
  height,
  emBezRef,
  isAndroid,
  isMovedDown,
  fadeBetween,
  topMove,
}) {
  const [isHighlighted, setIsHighlighted] = useState(highlighted);
  const [hovering, setHovering] = useState();
  const [fadingScreen, setFadingScreen] = useState();

  const [helpOverlay, setHelpOverlay] = useState(false);

  useEffect(() => {
    if (page === "Emulator" && !hideEOv) {
      setTimeout(() => {
        setHelpOverlay(true);
      }, 1000);
    } else {
      setHelpOverlay(false);
    }
  }, [page]);

  useEffect(() => {
    let time;
    const changeMyScreens = async () => {
      for (let i = 0; i < myScreen.length; i++) {
        if (i === 0) {
          setCurrentScreen(myScreen[i]);
        } else {
          const myPromise = new Promise((resolve) => {
            time = setTimeout(() => {
              if (i < myScreen.length) {
                const el = document.getElementById("fading-my-screen");
                el.classList.add("fading-my-screen-animation");
                resolve(setFadingScreen(() => myScreen[i]));
              }
            }, 700);
          });
          await myPromise.then(async () => {
            const myPromise2 = new Promise((resolve) => {
              time = setTimeout(() => {
                const el = document.getElementById("fading-my-screen");
                el.classList.remove("fading-my-screen-animation");
                resolve(setCurrentScreen(() => myScreen[i]));
              }, 700);
            });
            await myPromise2;
          });
        }
      }
    };
    if (myScreen && setCurrentScreen) {
      if (typeof myScreen === "object") {
        changeMyScreens();
      } else {
        setCurrentScreen(myScreen);
      }
    }
    if (isHighlighted !== highlighted) setIsHighlighted(highlighted);

    return () => {
      clearTimeout(time);
    };
  }, [myScreen]);

  const [mwidth, setMWidth] = useState(
    emBezRef.current ? emBezRef.current.getBoundingClientRect().width : "0"
  );

  const divRef1 = useRef();

  const [heightt, setHeightt] = useState(
    divRef1 && divRef1.current
      ? divRef1.current.getBoundingClientRect().height
      : 600
  );

  const handleWindowResize = () => {
    if (emBezRef.current) {
      setMWidth(emBezRef.current.getBoundingClientRect().width);
    }
    if (divRef1.current) {
      setHeightt(divRef1.current.getBoundingClientRect().height);
    }
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [divRef1 && divRef1.current]);

  return (
    <>
      <div
        className="em-icon"
        onClick={() => {
          if (helpOverlay && !hideEOv) {
            setHideEOv(true);
          }
          setHelpOverlay(!helpOverlay);
        }}
      >
        {page === "Emulator" && (
          <Tooltip title="Toggle Help" arrow placement="left">
            <HelpOutlineIcon
              className="toggleHelp"
              style={{
                height: "100%",
                width: "100%",
              }}
            />
          </Tooltip>
        )}
      </div>
      <div
        className={topMove ? "topmove topmoveplus" : "topmove"}
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "75%",
          //    backgroundColor:'pink',
          position: "absolute",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "80%",
            //  backgroundColor:"pink"
          }}
          ref={divRef1}
        >
          <div
            className="emulator-container2"
            style={
              page === "Emulator" && isAndroid
                ? {
                    marginBottom: "14vh",
                  }
                : page !== "Emulator"
                ? {
                    marginTop: "-1.5%",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    transform: heightt ? `scale(${heightt / 600})` : `scale(1)`,
                    transformOrigin: isMovedDown ? "top" : "center",
                  }
                : {}
            }
          >
            {!hideButtons && (
              <>
                <div
                  className="emulator-tv-buttons"
                  style={{ cursor: 'url("./images/webos-cursor.png"), auto' }}
                >
                  <div className="emulator-tv-buttons-inner">
                    {currentScreen &&
                      !hideScreenBtns &&
                      emuJSON[currentScreen].screen_buttons &&
                      emuJSON[currentScreen].screen_buttons.map((btn) => {
                        return (
                          <>
                            <button
                              className="emulator-button"
                              onClick={() => {
                                setCurrentScreen(btn.target);
                              }}
                              style={{
                                top: btn.top,
                                left: btn.left,
                                height: btn.h,
                                width: btn.w,
                                borderRadius: btn.radius ? btn.radius : null,
                                opacity:
                                  highlighted && highlighted !== btn.target
                                    ? 0.5
                                    : 1,
                              }}
                            ></button>
                            <button
                              onClick={() => {
                                setCurrentScreen(btn.target);
                                if (highlighted === btn.target) {
                                  switchScreens();
                                }
                              }}
                              onMouseEnter={() => {
                                setHovering(btn.target);
                              }}
                              onMouseLeave={() => {
                                setHovering(null);
                              }}
                              className="emulator-button"
                              style={{
                                top: btn.top,
                                left: btn.left,
                                height: btn.h,
                                width: btn.w,
                                borderRadius: btn.radius ? btn.radius : null,
                                opacity:
                                  highlighted && highlighted !== btn.target
                                    ? 0.5
                                    : 1,
                                backgroundColor:
                                  highlighted === btn.target ||
                                  hovering === btn.target
                                    ? "rgba(255, 0, 0, 0.3)"
                                    : "transparent",
                                animation:
                                  highlighted === btn.target
                                    ? "1.5s infinite pulse"
                                    : "none",
                                cursor:
                                  'url("./images/webos-cursor.png"), auto',
                              }}
                            ></button>
                          </>
                        );
                      })}
                    {customButton && customButton.screen ? (
                      <>
                        <button
                          className="emulator-button"
                          style={{
                            top: customButton.top,
                            left: customButton.left,
                            height: customButton.h,
                            width: customButton.w,
                            borderRadius: customButton.radius
                              ? customButton.radius
                              : null,
                            opacity:
                              highlighted && highlighted !== customButton.target
                                ? 0.5
                                : 1,
                          }}
                        ></button>
                        <button
                          onClick={() => {
                            if (emuJSON[customButton.target]) {
                              setCurrentScreen(customButton.target);
                              setEmulatorStep((prevState) => {
                                prevState++;
                                return prevState;
                              });
                            } else if (setEmulatorStep) {
                              setEmulatorStep((prevState) => {
                                prevState++;
                                return prevState;
                              });
                            }
                          }}
                          onMouseEnter={() => {
                            setHovering(customButton.target);
                          }}
                          onMouseLeave={() => {
                            setHovering(null);
                          }}
                          className="emulator-button"
                          style={{
                            top: customButton.top,
                            left: customButton.left,
                            height: customButton.h,
                            width: customButton.w,
                            borderRadius: customButton.radius
                              ? customButton.radius
                              : null,
                            opacity:
                              highlighted && highlighted !== customButton.target
                                ? 0.5
                                : 1,
                            backgroundColor:
                              highlighted === customButton.target ||
                              hovering === customButton.target
                                ? "rgba(255, 0, 0, 0.3)"
                                : "transparent",
                            animation:
                              highlighted === customButton.target &&
                              !customButton.bigger
                                ? "1.5s infinite pulse"
                                : highlighted === customButton.target &&
                                  customButton.bigger
                                ? "1.5s infinite middle-pulse"
                                : "none",
                            cursor: 'url("./images/webos-cursor.png"), auto',
                          }}
                        ></button>
                      </>
                    ) : null}
                  </div>
                </div>

                <div className="emulator-remote-buttons">
                  <div className="emulator-tv-buttons-inner">
                    {currentScreen &&
                      !hideRemoteBtns &&
                      emuJSON[currentScreen].remote_buttons &&
                      emuJSON[currentScreen].remote_buttons.map((btn) => {
                        return (
                          <>
                            <button
                              className="emulator-button"
                              onClick={() => {
                                setCurrentScreen(btn.target);
                              }}
                              style={{
                                top: btn.top,
                                left: btn.left,
                                height: btn.h,
                                width: btn.w,
                                borderRadius: btn.radius ? btn.radius : null,
                                opacity:
                                  highlighted && highlighted !== btn.target
                                    ? 0.5
                                    : 1,
                              }}
                            ></button>
                            <button
                              onClick={() => {
                                setCurrentScreen(btn.target);
                                if (highlighted === btn.target) {
                                  switchScreens();
                                }
                              }}
                              onMouseEnter={() => {
                                setHovering(btn.target);
                              }}
                              onMouseLeave={() => {
                                setHovering(null);
                              }}
                              className="emulator-button"
                              style={{
                                top: btn.top,
                                left: btn.left,
                                height: btn.h,
                                width: btn.w,
                                borderRadius: btn.radius ? btn.radius : null,
                                opacity:
                                  highlighted && highlighted !== btn.target
                                    ? 0.5
                                    : 1,
                                backgroundColor:
                                  highlighted === btn.target ||
                                  hovering === btn.target
                                    ? "rgba(255, 0, 0, 0.3)"
                                    : "transparent",
                                animation:
                                  highlighted === btn.target
                                    ? "1.5s infinite bigger-pulse"
                                    : "none",
                              }}
                            ></button>
                          </>
                        );
                      })}
                    {customButton && customButton.remote ? (
                      <>
                        <button
                          className="emulator-button"
                          style={{
                            top: customButton.top,
                            left: customButton.left,
                            height: customButton.h,
                            width: customButton.w,
                            borderRadius: customButton.radius
                              ? customButton.radius
                              : null,
                            opacity:
                              highlighted && highlighted !== customButton.target
                                ? 0.5
                                : 1,
                          }}
                        ></button>
                        <button
                          onClick={() => {
                            if (emuJSON[customButton.target]) {
                              setCurrentScreen(customButton.target);
                              if (highlighted === customButton.target) {
                                if (setEmulatorStep) {
                                  setEmulatorStep((prevState) => {
                                    prevState++;
                                    return prevState;
                                  });
                                }
                              }
                            } else if (
                              stepLength &&
                              stepLength > emulatorStep
                            ) {
                              setEmulatorStep((prevState) => {
                                prevState++;
                                return prevState;
                              });
                            }
                          }}
                          onMouseEnter={() => {
                            setHovering(customButton.target);
                          }}
                          onMouseLeave={() => {
                            setHovering(null);
                          }}
                          className="emulator-button"
                          style={{
                            top: customButton.top,
                            left: customButton.left,
                            height: customButton.h,
                            width: customButton.w,
                            borderRadius: customButton.radius
                              ? customButton.radius
                              : null,
                            opacity:
                              highlighted && highlighted !== customButton.target
                                ? 0.5
                                : 1,
                            backgroundColor:
                              (highlighted &&
                                highlighted === customButton.target) ||
                              hovering === customButton.target
                                ? "rgba(255, 0, 0, 0.3)"
                                : "transparent",
                            animation:
                              highlighted && highlighted === customButton.target
                                ? "1.5s infinite bigger-pulse"
                                : "none",
                          }}
                        ></button>
                      </>
                    ) : null}
                  </div>
                </div>
              </>
            )}
            {simPageNum &&
            emulatorStep &&
            pageJSON[simPageNum].content_data.steps &&
            pageJSON[simPageNum].content_data.steps[emulatorStep]
              .custom_step ? null : (
              <>
                {page === "Emulator" && helpOverlay && (
                  <>
                    <div
                      className="remote-em"
                      style={{
                        margin: "5px",
                        backgroundColor: "rgba(0,0,0,0)",
                        zIndex: 200,
                        height: "600px",
                        width: "152px",
                        borderRadius: "20px",
                        animationDelay: "0s",
                        pointerEvents: "all",
                      }}
                    ></div>

                    <div
                      className="screen"
                      style={{
                        margin: "0px",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 200,
                        height: "530px",
                        width: "959px",
                        cursor: 'url("./images/webos-cursor.png"), auto',
                      }}
                    >
                      <CloseIcon
                        style={{
                          color: "white",
                          fontSize: "1.8rem",
                          position: "absolute",
                          top: 20,
                          right: 20,
                          cursor: "pointer",
                          zIndex: 28,
                        }}
                        onClick={() => {
                          setHelpOverlay(false);
                        }}
                      />
                      <div
                        style={{
                          height: "calc(100% - 80px)",
                          width: "calc(100% - 40px)",
                          padding: "40px 20px",
                          position: "relative",
                          color: "white",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "2rem",
                            textAlign: "center",
                            marginBottom: "12px",
                          }}
                        >
                          How to use the webOS TV Emulator?
                        </p>
                        <hr
                          style={{
                            height: "1.6px",
                            border: "none",
                            backgroundColor: "white",
                            width: "470px",
                          }}
                        />

                        <p
                          style={{
                            fontWeight: 400,
                            fontSize: "1.4rem",
                            textAlign: "center",
                            padding: "0 260px",
                          }}
                        >
                          Control the webOS TV emulator by tapping the
                          highlighted buttons on{" "}
                          <span style={{ color: "#ff0099", fontWeight: 900 }}>
                            the screen
                          </span>{" "}
                          or the{" "}
                          <span style={{ color: "#ff0099", fontWeight: 900 }}>
                            remote control
                          </span>{" "}
                          to explore TV.
                          <br />
                        </p>
                      </div>
                    </div>
                  </>
                )}
                <div>
                  <img
                    className="screen"
                    style={{
                      zIndex: 7,
                      animation: "none",
                      animationDelay: "none",
                      opacity: 1,
                      height: "531px",
                    }}
                    src={`./images/screens/power-off.jpg`}
                    alt="webOS Homescreen"
                  />
                  <img
                    // id="em-screen"
                    className="screen"
                    style={{
                      animation: transitionSim
                        ? "load-this 0.5s forwards"
                        : "none",
                      animationDelay: "none",
                      zIndex: 8,
                      opacity: 1,
                      maxHeight: "531px",
                    }}
                    // currentScreen &&
                    // (currentScreen.includes("0") ||
                    //   currentScreen === "power-off")
                    //   ? "531px"
                    //   : null,
                    src={
                      currentScreen.includes(".jpg")
                        ? currentScreen
                        : `./images/emulator/${currentScreen}.jpg`
                    }
                    alt="webOS Homescreen"
                  />
                  {myScreen && typeof myScreen === "object" && fadeBetween ? (
                    <img
                      id="fading-my-screen"
                      className="fading-my-screen"
                      style={{
                        zIndex: 10,
                        maxHeight: "531px",
                      }}
                      // currentScreen &&
                      // (currentScreen.includes("0") ||
                      //   currentScreen === "power-off")
                      //   ? "531px"
                      //   : null,
                      src={
                        fadingScreen && fadingScreen.includes(".jpg")
                          ? fadingScreen
                          : `./images/emulator/${fadingScreen}.jpg`
                      }
                      alt="webOS Homescreen"
                    />
                  ) : null}
                  <img
                    ref={emBezRef}
                    className="bezel"
                    style={{
                      animation: "none",
                      animationDelay: "none",
                      opacity: 1,
                    }}
                    src="./images/tv-bezel-transp.png"
                    alt="LG TV"
                  />
                  <img
                    className="remote-em"
                    style={{
                      display:
                        pageJSON[simPageNum].center_image_data &&
                        pageJSON[simPageNum].center_image_data.hide_remote
                          ? "none"
                          : "",
                      animation: "none",
                      animationDelay: "none",
                      opacity: 1,
                    }}
                    src="./images/emulator/emulator-remote.png"
                    alt="LG TV Magic Remote"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "20%",
            // backgroundColor:"brown",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {pageJSON &&
          (simPageNum || simPageNum === 0) &&
          setIsEmulatorStep &&
          setTotalSteps &&
          pageJSON[simPageNum].content_data &&
          pageJSON[simPageNum].content_data.steps ? (
            <Temp
              isAndroid={isAndroid}
              pageJSON={pageJSON}
              simPageNum={simPageNum}
              setIsEmulatorStep={setIsEmulatorStep}
              emulatorStep={emulatorStep}
              setTotalSteps={setTotalSteps}
              isSingleStepScreen={isSingleStepScreen}
              setIsSingleStepScreen={setIsSingleStepScreen}
              page={page}
              mwidth={mwidth}
            />
          ) : (
            <div
              id="stepsbox"
              //className="steps-scale"
              style={{
                width: "100%",
                height: "100px",
                backgroundColor: "transparent",
                textAlign: "center",
                maxWidth: "1000px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></div>
          )}
        </div>
      </div>

      {page === "Emulator" ? (
        <Disclaimer emulator={true} remote={true} page={page} />
      ) : null}
    </>
  );
}
